import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, LoadingController, ModalController } from '@ionic/angular';
import { AddUserComponent } from 'src/app/components/add-user/add-user.component';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.page.html',
  styleUrls: ['./admins.page.scss'],
})
export class AdminsPage implements OnInit {
  admins  = [];
  adminsUnfiltered = [];

  searchName;
  isLoading: boolean = true;
  constructor(
    private menuCtrl: MenuController,
    private loadingCtrl: LoadingController,
    private router: Router,
    private modalCtrl: ModalController,
    private fireStoreService : FirestoreService

  ) {}

  ionViewWillEnter() {
    this.menuCtrl.enable(true);
  }

  ngOnInit() {
    this.loadingCtrl.create({ keyboardClose: true }).then((loadingEl) => {
      loadingEl.present();
      this.fireStoreService.getCollection(this.fireStoreService.ADMINS).subscribe(
        (res) => {
          this.isLoading = false;
          console.log(res);
          this.admins = res;
          this.adminsUnfiltered = this.admins;
          loadingEl.dismiss();
        },
        (err) => {
          this.isLoading = false;
          loadingEl.dismiss();
        }
      );
    });
  }


  async addNew() {
    const modal = await this.modalCtrl.create({
      component: AddUserComponent,
      cssClass: 'custom-modal',
      backdropDismiss : false
    });

    return await modal.present().catch((err) => {
      console.log(err);
    });
  }

  async edit(country, event) {
    const modal = await this.modalCtrl.create({
      component: AddUserComponent,
      componentProps: { country: country },
      cssClass: 'custom-modal',
       backdropDismiss : false
    });

    event.stopPropagation();
    return await modal.present().catch((err) => {
      console.log(err);
    });
  }

  onActivate(event) {
    if (event.type == 'click') {
      console.log(event.row);
    }
  }

  rowClicked(id, name) {
    this.router.navigate(['/cities'], {
      queryParams: {
        id: id,
        name: name,
      },
    });
  }

  search() {
    this.resetChanges();
    if (!(this.searchName === '')) {
      const searchResult = this.admins.filter((currentList) => {
        if (currentList.name && this.searchName) {
          return (
            currentList.name
              .toLowerCase()
              .indexOf(this.searchName.toLowerCase()) > -1
          );
        }
      });
      this.admins = searchResult;
    }
  }

  resetChanges() {
    this.admins = this.adminsUnfiltered;
  }
}
